/**
 * P1.1 — « Ma fiche en cours (N) ».
 *
 * Remplace l'ancienne entrée de navigation « Composer (N) » qui apparaissait /
 * disparaissait dans la NavBar (élément le plus déroutant de l'app — voir
 * docs/strategie-produit/ANALYSE_COMPLETE_PRODUIT_UX.md §3.1).
 *
 * Bouton flottant global : visible dès qu'au moins un exercice est
 * sélectionné, sauf sur la page de composition elle-même et dans l'admin.
 */
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FileText, ArrowRight } from "lucide-react";
import { useSelection } from "../contexts/SelectionContext";

const SelectionFloatingButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { selectionCount } = useSelection();

  // Refonte : la fiche est VISIBLE dans l'atelier (/generer) — le bouton n'y
  // a plus de raison d'être. Il ne sert plus qu'à revenir à sa fiche en cours
  // depuis les autres pages.
  const hidden =
    selectionCount === 0 ||
    location.pathname === "/" ||
    location.pathname === "/fiche" ||
    location.pathname === "/generer" ||
    location.pathname === "/fiches/nouvelle" ||
    location.pathname.startsWith("/admin");

  if (hidden) return null;

  return (
    <button
      onClick={() => navigate("/generer")}
      className="fixed bottom-5 right-5 z-50 hidden lg:flex items-center gap-2 rounded-full bg-foreground text-background hover:opacity-90 shadow-lg px-5 py-3 text-sm font-medium transition-opacity"
      aria-label={`Ma fiche en cours : ${selectionCount} exercice${selectionCount > 1 ? "s" : ""}`}
    >
      <FileText className="h-4 w-4" />
      Reprendre ma fiche ({selectionCount})
      <ArrowRight className="h-4 w-4" />
    </button>
  );
};

export default SelectionFloatingButton;
